// extracted by mini-css-extract-plugin
export var dropdownButton = "_39-0";
export var fullWidthDropdownButton = "_39-1";
export var icon = "_39-3";
export var iconPlaceholder = "_39-2";
export var shortcutContainer = "_39-4";